<template>
  <div class="panel">
    <!-- 社保 -->
    <div class="divider">{{ $t('420') }}</div>
    <el-form-item :label="$t('448')" prop="salary_last_ss">
      <el-input
        v-model="staffInfo.salary_last_ss"
        v-enterNumberPoint2
        v-enterNumberMax="1000000000"
        placeholder="0.00"
        :disabled="show"
      ></el-input>
    </el-form-item>
  </div>
</template>
<script>
export default {
  name: 'tax-info',
  components: {},
  props: {
    staffInfo: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.panel {
  overflow: hidden;
}
.divider {
  color: #262626;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
}
</style>
